import { FILTER_OPERATIONS, FilterType } from "../../../types/Filter";
import { IconX } from "@tabler/icons-react";
import { useSmartOptions } from "../../../fetch/fetch.item";
import ErrMessage from "../../core/ErrMessage";
import LoadingInput from "../../core/loading/LoadingInput";
import { useSearchParamsHandler } from "../../../hooks/useSearchParamsHandler";
import { useActiveParams } from "../../../hooks/useActiveParams";
import { FilterQueryType } from "../../../types/ItemQuery";

export function encode(value: FilterQueryType) {
  return encodeURIComponent(JSON.stringify(value));
}

export function decode(value: string): FilterQueryType {
  try {
    return JSON.parse(decodeURIComponent(value)) as FilterQueryType;
  } catch {
    return {
      _id: "parsingError",
      value: "passingError",
      option: FILTER_OPERATIONS.EQ,
    };
  }
}

const SingleFilter = ({ filter }: { filter: FilterType }) => {
  const { add, get, remove } = useSearchParamsHandler("filter");
  const { categorySlug } = useActiveParams();
  const { options, isLoading, isError } = useSmartOptions(
    categorySlug,
    filter._id,
    [],
  );
  const getCurrentValue = (filterId: string) => {
    const active = get().find((val) => {
      const test = decode(val);
      if (!test) return false;
      return test._id === filterId;
    });
    if (!active) return false;

    return decode(active);
  };

  const clearFilter = () => {
    const currentValue = getCurrentValue(filter._id);
    if (!currentValue) return;
    remove(encode(currentValue));
  };

  const setActive = (value: string | number) => {
    add(
      encode({
        _id: filter._id,
        value: value,
        option: FILTER_OPERATIONS.EQ,
      }),
    );
  };

  const activeValue = getCurrentValue(filter._id);

  if (activeValue) {
    return (
      <div className="btn btn-info" onClick={clearFilter}>
        {activeValue.value}
        <IconX />
      </div>
    );
  }

  if (isLoading) return <LoadingInput />;
  if (isError) return <ErrMessage message={isError.message} />;

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((value) => (
        <div
          key={value}
          className="btn btn-neutral active:btn-info"
          onClick={() => setActive(value)}
        >
          {value}
        </div>
      ))}
    </div>
  );
};
export default SingleFilter;
